"use client";
import { jsxs, jsx } from "react/jsx-runtime";
import CopyButton from "../../buttons/CopyButton/CopyButton.js";
import { useLocaleText } from "../../../hooks/useLocaleText.js";
import { sharedHandler } from "../../../shared/sharedHandler/sharedHandler.js";
import { log, toId } from "../../../utilities/index.js";
import { Title } from "@mantine/core";
import { forwardRef, useState, useEffect } from "react";
import { resolveTextColor } from "../typography.helpers.js";
import { mapHeadingTypesToOrder } from "./Heading.helpers.js";
import '../../../assets/Heading.css';const root = "_root_1xypf_2";
const copyButton = "_copyButton_1xypf_70";
const HeadingStyles = {
  root,
  copyButton
};
const _Heading = forwardRef((props, ref) => {
  const {
    type = "h1",
    text,
    className,
    variant = "primary",
    generateAnchor = false,
    id,
    align,
    mod,
    ...rest
  } = props;
  const [clicked, setClicked] = useState(false);
  const texts = useLocaleText();
  const timeout = 2e3;
  useEffect(() => {
    var _a;
    if (!text || text === "") {
      log({
        message: `A Heading component did not get the mandatory text. This happened here: ${(_a = window == null ? void 0 : window.location) == null ? void 0 : _a.href}`,
        type: "error"
      });
    }
  }, []);
  const anchorId = id || text && toId(JSON.stringify(text) || "###");
  const anchor = `#${anchorId}`;
  const clickHandler = () => {
    setClicked(true);
    setTimeout(() => {
      setClicked(false);
    }, timeout);
  };
  return /* @__PURE__ */ jsxs(
    Title,
    {
      ...rest,
      ta: align,
      c: resolveTextColor(variant),
      order: mapHeadingTypesToOrder(type),
      mod: { type, "with-anchor": generateAnchor && anchorId, ...mod },
      classNames: HeadingStyles,
      className,
      ref,
      onClick: clickHandler,
      id: generateAnchor ? anchorId : id,
      children: [
        text,
        generateAnchor && /* @__PURE__ */ jsx(
          CopyButton,
          {
            control: clicked,
            text: anchor,
            notificationLabel: texts.linkCopied,
            ml: "sm",
            timeout,
            className: HeadingStyles.copyButton,
            variant: "anchor"
          }
        )
      ]
    }
  );
});
_Heading.displayName = "Heading";
const Heading = sharedHandler(_Heading);
Heading.displayName = _Heading.displayName;
export {
  HeadingStyles as H,
  Heading as default
};
